import { THEMES } from 'src/constants';

export const TOBSA_CLIENT = 'brp-group';

export const tobsa = {
    siteName: 'tobsa',
    senderName: 'Tobsa Group',
    logo: '/static/warbox_logo.png',
    name: 'Tobsa Group',
    bureauSite: 'tobsa.warbox.io',
    theme: THEMES.LIGHT,
    client: TOBSA_CLIENT,
    themes: [
        { theme: 'BRP_LIGHT', name: 'BRP LIGHT' },
        { theme: 'BRP_DARK', name: 'BRP DARK' },
        { theme: 'LIGHT', name: 'LIGHT' },
        { theme: 'ONE_DARK', name: 'DARK' },
        { theme: 'DARK_PINK', name: 'DARK PINK' },
        { theme: 'LIGHT_PINK', name: 'LIGHT PINK' },
        { theme: 'DARK_BLUE', name: 'DARK BLUE' },
        { theme: 'LIGHT_BLUE', name: 'LIGHT BLUE' },
        { theme: 'DARK_RED', name: 'DARK RED' },
        { theme: 'LIGHT_RED', name: 'LIGHT RED' },
        { theme: 'DARK_LILA', name: 'DARK LILA' },
        { theme: 'LIGHT_LILA', name: 'LIGHT LILA' },
    ],
};
